import React, { FunctionComponent } from 'react'

import { Container, Info, NoWrap } from './style'

export const Footer: FunctionComponent<{}> = () => {
  return (
    <Container>
      <Info>
        <NoWrap>&copy; 2019</NoWrap> <NoWrap>Kilian Wimmer</NoWrap>
      </Info>
    </Container>
  )
}
